import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEudrInformationResponsePayload,
	TEudrPlansResponsePayload,
	TEudrStatusResponsePayload,
	TEudrStore,
	TEudrUploadedFilesRequestPayload,
	TEudrUploadedFilesResponsePayload,
} from './types';

export const initialState: TEudrStore = {
	status: null,
	statusLoading: false,
	plans: null,
	plansLoading: false,
	information: null,
	informationLoading: false,
	uploadedFiles: null,
	uploadedFilesLoading: false,
	uploadFileLoading: false,
	downloadFileLoading: false,
};

const eudr = createSlice({
	name: '@@eudr',
	initialState,
	reducers: {
		getEudrStatusRequest: (state: TEudrStore) => {
			const nextState = state;
			nextState.statusLoading = true;
		},
		getEudrStatusSuccess: (
			state: TEudrStore,
			action: PayloadAction<TEudrStatusResponsePayload>,
		) => {
			const nextState = state;
			nextState.status = action.payload;
			nextState.statusLoading = false;
		},
		getEudrPlansRequest: (state: TEudrStore) => {
			const nextState = state;
			nextState.plansLoading = true;
		},
		getEudrPlansSuccess: (state: TEudrStore, action: PayloadAction<TEudrPlansResponsePayload>) => {
			const nextState = state;
			nextState.plans = action.payload;
			nextState.plansLoading = false;
		},
		getEudrInformationRequest: (state: TEudrStore) => {
			const nextState = state;
			nextState.informationLoading = true;
		},
		getEudrInformationSuccess: (
			state: TEudrStore,
			action: PayloadAction<TEudrInformationResponsePayload>,
		) => {
			const nextState = state;
			nextState.information = action.payload;
			nextState.informationLoading = false;
		},
		uploadFileRequest: (state: TEudrStore, action: PayloadAction<FormData>) => {
			const nextState = state;
			nextState.uploadFileLoading = true;
		},
		uploadFileSuccess: (state: TEudrStore) => {
			const nextState = state;
			nextState.uploadFileLoading = false;
		},
		downloadFileRequest: (state: TEudrStore, action: PayloadAction<number>) => {
			const nextState = state;
			nextState.downloadFileLoading = true;
		},
		downloadFileSuccess: (state: TEudrStore) => {
			const nextState = state;
			nextState.downloadFileLoading = false;
		},
		getUploadedFilesRequest: (
			state: TEudrStore,
			action: PayloadAction<TEudrUploadedFilesRequestPayload>,
		) => {
			const nextState = state;
			nextState.uploadedFilesLoading = true;
		},
		getUploadedFilesSuccess: (
			state: TEudrStore,
			action: PayloadAction<TEudrUploadedFilesResponsePayload>,
		) => {
			const nextState = state;
			nextState.uploadedFiles = action.payload;
			nextState.uploadedFilesLoading = false;
		},
		eudrInitState: () => initialState,
	},
});

export default eudr.reducer;
export const {
	getEudrStatusRequest,
	getEudrStatusSuccess,
	getEudrPlansRequest,
	getEudrPlansSuccess,
	getEudrInformationRequest,
	getEudrInformationSuccess,
	uploadFileRequest,
	uploadFileSuccess,
	downloadFileRequest,
	downloadFileSuccess,
	getUploadedFilesRequest,
	getUploadedFilesSuccess,
	eudrInitState,
} = eudr.actions;
